<template>
  <div class="content">
    <div>
      <div
        id="success-notification-content"
        class="toastify-content hidden flex"
        v-if="toastSuccess"
      >
        <CheckCircleIcon class="text-theme-9" />
        <div class="ml-4 mr-4">
          <div class="font-medium">{{ toastSuccessMsg }}</div>
          <div class="text-gray-600 mt-1">
            {{ toastSuccessDesc }}
          </div>
        </div>
      </div>

      <div
        id="error-notification-content"
        class="toastify-content hidden flex"
        v-if="toastError"
      >
        <AlertCircleIcon class="text-theme-6" />
        <div class="ml-4 mr-4">
          <div class="font-medium">{{ toastErrorMsg }}</div>
          <div class="text-gray-600 mt-1" v-html="toastErrorDesc"></div>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from '@/store'
export default {
  setup() {
    const store = useStore()
    const toastSuccess = computed(() => store.state.notification.toastSuccess)
    const toastSuccessMsg = computed(
      () => store.state.notification.toastSuccessMsg
    )
    const toastSuccessDesc = computed(
      () => store.state.notification.toastSuccessDesc
    )
    const toastError = computed(() => store.state.notification.toastError)
    const toastErrorMsg = computed(() => store.state.notification.toastErrorMsg)
    const toastErrorDesc = computed(
      () => store.state.notification.toastErrorDesc
    )
    return {
      toastSuccess,
      toastSuccessMsg,
      toastSuccessDesc,
      toastError,
      toastErrorMsg,
      toastErrorDesc
    }
  }
}
</script>
